import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function ProtectedRoute({ children, role }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="flex h-[60vh] items-center justify-center text-[#5C6873] font-body" data-testid="auth-loading">
        Checking session…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (role) {
    const roles = Array.isArray(role) ? role : [role];
    const allowed = roles.includes(user.role) || user.role === "admin";
    if (!allowed) return <Navigate to="/dashboard" replace />;
    // Authority needs active status for role-gated routes (other than the dashboard itself).
    if (user.role === "authority" && roles.includes("authority") && user.status !== "active") {
      return <Navigate to="/dashboard" replace />;
    }
  }
  return children;
}
